import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelText as _vModelText, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2df6a602"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Back to Waitlist")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Add To Waiting List ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Edit Waiting List ")
const _hoisted_4 = { class: "container" }
const _hoisted_5 = ["onSubmit"]
const _hoisted_6 = {
  key: 0,
  class: "row horizontal-center"
}
const _hoisted_7 = { class: "form-check" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "is_existing_customer" }, "Existing Customer", -1))
const _hoisted_9 = { class: "form-check" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "is_not_existing_customer" }, "New Customer", -1))
const _hoisted_11 = { class: "form-field" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Unit Type", -1))
const _hoisted_13 = ["disabled", "value"]
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Available for reserve/rental")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("(Waitlist spots)")
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "form-field" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "First Name", -1))
const _hoisted_19 = { class: "form-field" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Last Name", -1))
const _hoisted_21 = { class: "form-field" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Email", -1))
const _hoisted_23 = { class: "form-field" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Cell phone", -1))
const _hoisted_25 = {
  key: 2,
  class: "form-field"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Customer", -1))
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "form-field" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Caller Phone Number", -1))
const _hoisted_31 = { class: "form-field" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Desired Move-In Date", -1))
const _hoisted_33 = { class: "form-field" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Notes", -1))
const _hoisted_35 = { class: "form-field" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = {
  key: 0,
  class: "col"
}
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Adding to waiting list ")
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Updating ")
const _hoisted_40 = {
  key: 1,
  class: "col"
}
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Add to waiting list ")
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Update ")
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_44 = { key: 1 }

import { onMounted, ref } from "vue";

import api from "@virgodev/bazaar/functions/api";

import BaseSpinner from "@/components/BaseSpinner.vue";
import { useRouter } from "vue-router";
import { UnitDetailInterface } from "@/types/customers";

export default /*#__PURE__*/_defineComponent({
  props: {
  waitlistId: {
    type: String,
    default: null,
  },
  facilityId: {
    type: String,
    default: null,
  },
  facilityName: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

const router = useRouter();

const status = ref("loading");
const errors = ref("");
const unitTypes = ref();
const units = ref();
const customers = ref();
const formSubmitting = ref(false);
const formErrors = ref<Record<string, string[]>>({});
const loadedId = ref(false);
const desiredUnitType = ref();


const formFields = ref({
  existing_customer: false,

  lead: {
    tenant_id: ref(null),
    quoted_rate: ref(null),
    tenant_attributes: {
      first_name: ref(null),
      last_name: ref(null),
      email: ref(null),
      phone_numbers_attributes: [
        {
          label: ref(null),
          number: ref(null),
          extension: ref(null),
        },
      ],
    },
    is_reservation: false,
    notes_attributes: [
      {
        note: "",
      },
    ],
    caller_phone_attributes: {
      number: "",
    },
    unit_id: "",
    desired_unit_size_and_price: "",
    desired_move_in_date: ref(null),
  },
});

onMounted(async () => {
  await getWaitlist();
  await getUnits();
  status.value = "loaded";
});
async function getUnitTypes() {
  errors.value = "";
  const response = await api({
    url: `unit_types/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    unitTypes.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getCustomers() {
  errors.value = "";
  const response = await api({
    url: `customers/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    customers.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getUnits() {
  let url = `units/?facilityId=${props.facilityId}`;

  errors.value = "";

  const response = await api({
    url,
  });

  if (response.status == 200) {
    units.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getWaitlist() {
  await getUnitTypes();
  await getCustomers();
  if (props.waitlistId) {
    errors.value = "";
    loadedId.value = true;
    const response = await api({
      url: `waiting_customers/?id=${props.waitlistId}&facilityId=${props.facilityId}`,
    });
    if (response.status == 200) {
      formFields.value = response.body;
    } else {
      errors.value =
        "Unable to communicate with the server. Please check your " +
        "connection and try again.";
    }
  }
}

async function submitForm() {
  formFields.value.lead.desired_unit_size_and_price =
    desiredUnitType.value.size;
  formFields.value.lead.quoted_rate = desiredUnitType.value.price;
  formFields.value.lead.unit_id = units.value.filter(
    (item: UnitDetailInterface) =>
      item.unit_group_id == desiredUnitType.value.id
  )[0].id;

  const json = JSON.parse(JSON.stringify(formFields.value));
  if (json.existing_customer) {
    delete json.lead.tenant_attributes;
  }
  delete json.existing_customer;

  formErrors.value = {};
  formSubmitting.value = true;
  let url = `waiting_customers/?facilityId=${props.facilityId}`;
  let method: "POST" | "PUT" = "POST";

  if (props.waitlistId) {
    url += `&id=${props.waitlistId}/`;
    method = "PUT";
  }

  const responseData = await api({
    url,
    method,
    json,
  });

  formSubmitting.value = false;
  if ([200, 201].includes(responseData.status)) {
    router.push({
      name: "waitlist",
      params: {
        facilityId: props.facilityId,
        facilityName: props.facilityName,
      },
    });
  } else if (responseData.status === 400) {
    formErrors.value = responseData.body;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_RouterLink, {
      class: "btn",
      to: {
      name: 'waitlist',
      params: { facilityId: __props.facilityId, facilityName: __props.facilityName },
    }
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["to"]),
    _createElementVNode("h1", null, [
      (!__props.waitlistId)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_2
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_3
          ], 64))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (status.value === 'loading')
        ? (_openBlock(), _createBlock(BaseSpinner, {
            key: 0,
            preset: "large"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("form", {
        class: "well large-width-centered",
        onSubmit: _withModifiers(submitForm, ["prevent"])
      }, [
        (!__props.waitlistId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  id: "is_existing_customer",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formFields.value.existing_customer) = $event)),
                  type: "radio",
                  value: true,
                  class: _normalizeClass(["form-check-input", {
              'is-invalid': formErrors.value.existing_customer !== undefined,
            }]),
                  required: ""
                }, null, 2), [
                  [_vModelRadio, formFields.value.existing_customer]
                ]),
                _hoisted_8
              ]),
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  id: "is_not_existing_customer",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formFields.value.existing_customer) = $event)),
                  type: "radio",
                  value: false,
                  class: _normalizeClass(["form-check-input", {
              'is-invalid': formErrors.value.existing_customer !== undefined,
            }]),
                  required: ""
                }, null, 2), [
                  [_vModelRadio, formFields.value.existing_customer]
                ]),
                _hoisted_10
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((desiredUnitType).value = $event)),
            required: "",
            class: "form-select"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unitTypes.value, (unitType) => {
              return (_openBlock(), _createElementBlock("option", {
                key: unitType + 'id',
                disabled: unitType.available_units_count >= 1,
                value: unitType
              }, [
                _createTextVNode(_toDisplayString(unitType.size) + " ", 1),
                (unitType.available_units_count >= 1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_14
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_15
                    ], 64))
              ], 8, _hoisted_13))
            }), 128))
          ], 512), [
            [_vModelSelect, desiredUnitType.value]
          ])
        ]),
        (!formFields.value.existing_customer && !__props.waitlistId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formFields.value.lead.tenant_attributes.first_name) = $event)),
                  type: "text",
                  required: ""
                }, null, 512), [
                  [_vModelText, formFields.value.lead.tenant_attributes.first_name]
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formFields.value.lead.tenant_attributes.last_name) = $event)),
                  type: "text",
                  required: ""
                }, null, 512), [
                  [_vModelText, formFields.value.lead.tenant_attributes.last_name]
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formFields.value.lead.tenant_attributes.email) = $event)),
                  type: "text",
                  required: ""
                }, null, 512), [
                  [_vModelText, formFields.value.lead.tenant_attributes.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((
              formFields.value.lead.tenant_attributes.phone_numbers_attributes[0]
                .number
            ) = $event)),
                  type: "text",
                  required: ""
                }, null, 512), [
                  [_vModelText, 
              formFields.value.lead.tenant_attributes.phone_numbers_attributes[0]
                .number
            ]
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _hoisted_26,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formFields.value.lead.tenant_id) = $event)),
                class: "form-select",
                required: "",
                disabled: loadedId.value
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customers.value, (c) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: c.id + 'customer',
                    value: c.id
                  }, _toDisplayString(c.first_name) + " " + _toDisplayString(c.last_name), 9, _hoisted_28))
                }), 128))
              ], 8, _hoisted_27), [
                [_vModelSelect, formFields.value.lead.tenant_id]
              ])
            ])),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formFields.value.lead.caller_phone_attributes.number) = $event)),
            type: "text",
            required: ""
          }, null, 512), [
            [_vModelText, formFields.value.lead.caller_phone_attributes.number]
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formFields.value.lead.desired_move_in_date) = $event)),
            type: "date",
            required: ""
          }, null, 512), [
            [_vModelText, formFields.value.lead.desired_move_in_date]
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formFields.value.lead.notes_attributes[0].note) = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, formFields.value.lead.notes_attributes[0].note]
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("button", {
            disabled: formSubmitting.value,
            type: "submit",
            class: "btn btn-text"
          }, [
            (formSubmitting.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  (!__props.waitlistId)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_38
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_39
                      ], 64)),
                  _createVNode(BaseSpinner)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  (!__props.waitlistId)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_41
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_42
                      ], 64))
                ]))
          ], 8, _hoisted_36),
          _createVNode(_component_RouterLink, {
            to: {
            name: 'waitlist',
            params: { facilityId: __props.facilityId, facilityName: __props.facilityName },
          },
            class: "btn btn-text"
          }, {
            default: _withCtx(() => [
              _hoisted_43
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ], 40, _hoisted_5),
      (errors.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(errors.value), 1))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})